// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__jVfOz","backanime":"Modal_backanime__hzJyv","modal":"Modal_modal__jfXIS","modalanime":"Modal_modalanime__ejnt9"};